import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  immediate = false,
}) => {
  const anim = immediate
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, margin: "-60px" } };
  return (
    <motion.span
      className={className}
      initial="hidden"
      {...anim}
      variants={{ hidden: {}, show: { transition: { staggerChildren: stagger, delayChildren: delay } } }}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            variants={{
              hidden: { y: "115%" },
              show: { y: "0%", transition: { duration: 0.95, ease: EASE } },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Overline = ({ children, className = "", light = false }) => (
  <p
    className={`font-mono text-[11px] uppercase tracking-[0.28em] ${
      light ? "text-slate-400" : "text-slate-500"
    } ${className}`}
  >
    {children}
  </p>
);

export const Chapter = ({ index, label, light = false }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className={`font-mono text-[11px] tracking-[0.2em] ${light ? "text-signal" : "text-signal"}`}>
      {index}
    </span>
    <span className={`h-px flex-1 ${light ? "bg-white/10" : "bg-slate-200"}`} />
    <Overline light={light}>{label}</Overline>
  </div>
);
